// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"8f58ff1c","124":"d4ad6553","492":"fd398a20","606":"62b6e520","660":"bb579ee2","667":"7fed46d2","935":"e70f30e0","939":"fb37026d"}[chunkId] + ".chunk.js";
};